import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcaseTag12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSuitcaseTag12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 1h1a.5.5 0 0 1 .5.5V3H5V1.5a.5.5 0 0 1 .5-.5M4 3V1.5A1.5 1.5 0 0 1 5.5 0h1A1.5 1.5 0 0 1 8 1.5V3h2.5A1.5 1.5 0 0 1 12 4.5v5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5v-5A1.5 1.5 0 0 1 1.5 3zm0 5v2h4V4H4v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1zM3 8v2H1.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H3v1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m.5-2H3v1h2V6zm7 4H9V4h1.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcaseTag12);
